/* eslint-disable @typescript-eslint/no-namespace */
import logo, { logoVariants } from './logo';
import textContent, { textContentVariants } from './text-content';
import type { Utility } from '../../../types/utility';

export namespace Nav {
  /** Nav Component Variant Keys */
  export type ComponentKeys = 'logo' | 'textContent';

  /** Nav Components */
  export type Components = {
    /** The Nav Dropdown Heading component types. */
    Label: Label.VariantKeys;
    /** The Nav.Logo component types. */
    Logo: Logo.VariantKeys;
    /** The Nav Dropdown Text Content component types. */
    TextContent: TextContent.VariantKeys;
  };

  /** Nav Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'label'
      ? Label.Variants
      : CompKey extends 'logo'
        ? Logo.Variants
        : CompKey extends 'textContent'
          ? TextContent.Variants
          : never;
  };

  /** Nav Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<
      CompKey extends 'label'
        ? Label.Variants
        : CompKey extends 'logo'
          ? Logo.Variants
          : CompKey extends 'textContent'
            ? TextContent.Variants
            : never
    >;
  };

  /** Nav Label Component */
  export namespace Label {
    /** Nav Label Component Variant Keys */
    export type VariantKeys = 'siteNav' | 'globalNav';

    /** Nav Label Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Nav Logo Component */
  export namespace Logo {
    /** Nav Logo Component Variant Keys */
    export type VariantKeys = 'default' | 'learningCampus';

    /** Nav Logo Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Nav Dropdown Text Content Component */
  export namespace TextContent {
    /** Nav Dropdown Text Content Component Variant Keys */
    export type VariantKeys = 'siteNav' | 'globalNav';

    /** Nav Dropdown Text Content Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Nav Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'label'
      ? Array<`${CompKey}.${Label.VariantKeys}`>
      : CompKey extends 'logo'
        ? Array<`${CompKey}.${Logo.VariantKeys}`>
        : CompKey extends 'textContent'
          ? Array<`${CompKey}.${TextContent.VariantKeys}`>
          : never;
  };
}

export const navVariants = {
  logo: logoVariants,
  textContent: textContentVariants,
};

const nav = {
  logo,
  textContent,
};

export default nav;
